import { ReactNode } from 'react';
import { BulletPoint } from '@/web/components/BulletPoints/BulletPoint';
import { themeSprinkles } from '@coverflex-tech/hypernova';

export const BulletPoints = ({ points }: IBulletPointsProps) => {
  return (
    <ul
      className={themeSprinkles({
        display: 'flex',
        flexDirection: 'column',
        gap: 'sm',
      })}
    >
      {points.map((point, idx) => (
        <BulletPoint key={idx}>{point}</BulletPoint>
      ))}
    </ul>
  );
};

interface IBulletPointsProps {
  points: ReactNode[];
}
